export enum BiteLogParPayEvent {
  None = 0,
  TerminalConnected = 1,
  TerminalDisconnected = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  DeviceSetup = 5,
  CloseTransaction = 6,
  CloseTransactionError = 7,
  NativeTransaction = 8,
  NativeRefundTransaction = 9,
  RefundTransactionRequested = 10,
  RefundTransaction = 11,
  RefundTransactionError = 12,
  Logs = 13,
  CardBinRequest = 14,
  CardBinRequestError = 15,
  TerminalRebootRequested = 16,
  TerminalRebootSkipped = 17,
}
